export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserDetailsStore();
  if (userStore?.accountLevel?.toLowerCase() === 'manage only') {
    return navigateTo('/manage-jobs/active');
  }
});
